export default "__VITE_ASSET__DeC5L55K__"